$(document).on('ajaxStop', function () {
    $(this).find('.input-group-append').closest('.input-group').each(
        function () {
            if (!$(this).hasClass('js-select-group')) {
                $(this).addClass('js-select-group');
            }
        }
    )
});